export let ContentType = /*#__PURE__*/function (ContentType) {
  ContentType["PDF"] = "application/pdf";
  ContentType["XLSX"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  return ContentType;
}({});